<template>
  <div class="exp-content-view container">
    <el-card shadow="never">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:20px">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/personal/course'}">我的资源</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:`/resource/${$route.params.courseId}`}">实验项目</el-breadcrumb-item>
            <el-breadcrumb-item>预览详情</el-breadcrumb-item>
        </el-breadcrumb>
        <expRunDoc :expContentType="dataForm.expContentType" :uid="dataForm.uid" :expRecordInfo="dataForm"/>
    </el-card>
  </div>
</template>
<script>
import expRunDoc from './components/exp-doc-view'
import { getEntity } from '@/api/exp/experiment'
// import { getFileInfoByUid } from '@/api/file'


export default {
  data() {
    return {
      dataForm: {
        expContentType: null
      },
      pdfUrl: '',
      expRecordInfo:{}
    }
  },
  components: { expRunDoc },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getExpEntity()
      // this.getMyExpDetail()
    },
    getExpEntity() {
      const { id } = this.$route.params
      getEntity(id).then(res => {
        this.dataForm = res
        // if (this.dataForm.expContentType == 3) {
        //   getFileInfoByUid(this.dataForm.expContent).then(res => {
        //     this.pdfUrl = res.originalPath
        //   })
        // }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.exp-content-view {
  .lab-pdf {
    height: 600px;
    embed {
      width: 100%;
      height: 100%;
    }
  }
  .lab-editor {
    overflow: auto;
  }
}
</style>
